var React = require('react');

function NumberTwoInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12.5001 22.782C6.90002 22.782 2.34387 18.2259 2.34387 12.6258C2.34387 7.02569 6.90002 2.46954 12.5001 2.46954C18.1002 2.46954 22.6564 7.02569 22.6564 12.6258C22.6564 18.2259 18.1002 22.782 12.5001 22.782Z","fill":"#FA7360","key":0}),React.createElement("path",{"d":"M9.55717 18H16.5373V16.4588H12.1026V16.3892L13.8576 14.6044C15.8363 12.7053 16.3832 11.7805 16.3832 10.6321C16.3832 8.92685 14.9961 7.67898 12.9478 7.67898C10.9293 7.67898 9.49751 8.93182 9.49751 10.8658H11.2525C11.2525 9.8267 11.9087 9.17543 12.9229 9.17543C13.8924 9.17543 14.6133 9.76705 14.6133 10.7266C14.6133 11.5767 14.0962 12.1832 13.092 13.2024L9.55717 16.6676V18Z","fill":"white","key":1})]);
}

NumberTwoInline.defaultProps = {"viewBox":"0 0 25 26","fill":"none"};

module.exports = NumberTwoInline;

NumberTwoInline.default = NumberTwoInline;
